var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 115,
    viewBox: "0 0 58 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smartphone"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 58,
    height: 115,
    rx: 5,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 29,
    cy: 110,
    r: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 96
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 8,
    y: 8,
    width: 42,
    height: 96,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 9,
    y: 36,
    width: 40,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 9,
    y: 8,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: -6.7868,
    y: 43.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 -6.7868 43.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 13,
    y: 39.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 13 39.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 9.5,
    y: 8.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 9,
    y: 42,
    width: 15,
    height: 5,
    rx: 2,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 9,
    y: 42,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HeadLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_2",
    x: 26,
    y: 42,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_2",
    x: 26,
    y: 42,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_3",
    x: 9,
    y: 62,
    width: 22,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_3",
    x: 9,
    y: 62,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_4",
    x: 9,
    y: 56,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_4",
    x: 9,
    y: 56,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_5",
    x: 9,
    y: 50,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_5",
    x: 9,
    y: 50,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_6",
    x: 29,
    y: 50,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_6",
    x: 29,
    y: 50,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_7",
    x: 40,
    y: 50,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_7",
    x: 40,
    y: 50,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ImgWithText"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 89,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12_2",
    x: 9,
    y: 89,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10_2",
    x: -6.7868,
    y: 124.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 -6.7868 124.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11_2",
    x: 13,
    y: 120.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 13 120.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9_2",
    x: 9.5,
    y: 89.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_8",
    x: 9,
    y: 68,
    width: 14,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_8",
    x: 9,
    y: 68,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_9",
    x: 41,
    y: 62,
    width: 8,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_9",
    x: 41,
    y: 62,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_10",
    x: 33,
    y: 62,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_10",
    x: 33,
    y: 62,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_11",
    x: 36,
    y: 56,
    width: 13,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_11",
    x: 36,
    y: 56,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 9,
    y: 76,
    width: 30,
    height: 8,
    rx: 2,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 9,
    y: 76,
    width: 30,
    height: 7,
    rx: 2,
    fill: "#282C34"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.e18b1faa66785d8107b42c211ba595dc.svg";
export { ForwardRef as ReactComponent };